import { useEffect } from 'react';

/**
 * Portal invisível para renderização de conteúdo de impressão A4
 * Este componente cria o container #print-root usado pelo hook usePrintA4
 */
export function PrintA4Portal() {
  useEffect(() => {
    // Criar #print-root se não existir
    if (!document.getElementById('print-root')) {
      const printRoot = document.createElement('div');
      printRoot.id = 'print-root';
      printRoot.className = 'print-only';
      printRoot.style.cssText = 'position:fixed;left:-9999px;top:0;opacity:0;pointer-events:none;';
      printRoot.setAttribute('aria-hidden', 'true');
      document.body.appendChild(printRoot);
    }

    return () => {
      // Cleanup quando o componente for desmontado
      const printRoot = document.getElementById('print-root');
      if (printRoot && !document.body.classList.contains('printing')) {
        printRoot.remove();
      }
    };
  }, []);

  return null;
}
